import { GeolocationService } from "./GeolocationService";
import { RandomIdGenerator } from "./RandomIdGenerator";
const randomIdGenerator = new RandomIdGenerator();
const geolocationService = new GeolocationService();
export { randomIdGenerator, geolocationService, };
